import React from 'react'
import { observer } from 'mobx-react-lite'

import { useGlobalCopyStore, useGoalStore } from '../../../common'
import { Goal, TrackType } from '../../../core'
import { ListItemAction } from '../../../common'
import TextField from '@mui/material/TextField'

interface GoalNameActionProps {
  goal: Goal
}

export const GoalNameAction = observer(({ goal }: GoalNameActionProps) => {
  const { goals: copy } = useGlobalCopyStore()
  const { setAlert, setSelectedGoal, updateGoal } = useGoalStore()

  const [name, setName] = React.useState(goal.name)

  const isNew = !goal.guid
  const isDisabled =
    (goal.track_type === TrackType.SAVINGS_TRACK && goal.has_been_spent) ||
    (goal.track_type !== TrackType.SAVINGS_TRACK && goal.is_complete)

  const handleSaveName = async () => {
    const updatedGoal = { ...goal, name }
    goal.name = name
    if (isNew) {
      setSelectedGoal(updatedGoal)
    } else {
      await updateGoal(updatedGoal)
      setAlert(copy.alert_goal_updated_name)
    }
  }

  const handleCancel = () => {
    setTimeout(() => {
      setName(goal.name)
    }, 250)
  }

  return (
    <ListItemAction
      isDisabled={isDisabled}
      isSaveDisabled={!name}
      label={copy.details_goal_name}
      onCancel={handleCancel}
      onSave={handleSaveName}
      primaryText={copy.details_goal_name}
      secondaryText={goal.name}
    >
      <TextField
        error={!name}
        fullWidth={true}
        label={copy.details_goal_name}
        onChange={(event) => setName(event.target.value)}
        value={name}
      />
    </ListItemAction>
  )
})
